import { render, staticRenderFns } from "./RequestTable.vue?vue&type=template&id=6e6ef8b6"
import script from "./RequestTable.vue?vue&type=script&lang=js"
export * from "./RequestTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports